import { AuthContext } from './AuthContext.ts';
import { useAuthProvider } from './useAuthProvider.ts';

type Props = {
  children: React.ReactNode;
};

/**
 * {@link AuthProvider} is a context provider component to make useAuth() available to our app.
 */
export function AuthProvider({ children }: Props) {
  const auth = useAuthProvider();

  return <AuthContext value={auth}>{children}</AuthContext>;
}
